module.exports = __webpack_public_path__ + "static/media/postman-logo.31fce90e.jpeg";